import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  Select,
  MenuItem,
  withStyles,
  FormHelperText,
  Input,
} from '@material-ui/core'
import ColorPicker from './ColorPicker'

const styles = theme => ({
  notchedOutline: {
    borderRadius: 28,
    paddingLeft: '40px !important',
  },
})

export default connect(
  (state, { valuePath, errorPath, value, error }) => ({
    value:
      typeof value === 'string' ? value : valuePath ? valuePath(state) : null,
    error: error ? error : errorPath ? errorPath(state) : null,
  }),
  (dispatch, { handleChangeFuncPath, handleChangeFunc, onChange }) => {
    if (onChange) {
      return { onChange }
    }
    
    if (handleChangeFuncPath) {
      const handleChange = handleChangeFunc
        ? require(`../${handleChangeFuncPath}`)[handleChangeFunc]
        : require(`../${handleChangeFuncPath}`)
      return bindActionCreators({ handleChange })
    }
    return bindActionCreators({}, dispatch)
  },
)(
  withStyles(styles)(
    class TextField extends Component {
      componentDidMount() {
        this.forceUpdate()
      }

      render() {
        const {
          value,
          handleChange,
          onChange,
          property,
          label,
          disabled,
          placeholder,
          select,
          items,
          color,
          error,
          classes,
          selectTemplate,
          variant,
          type,
          helperText,
        } = this.props

        const InputComponent = variant === 'standard' ? Input : OutlinedInput

        const handleValueChange = (e) => {
          if (handleChange) {
            handleChange(property, (e && e.target && e.target.value) || '')
          } else if (onChange) {
            onChange(e)
          }
        }

        return (
          <FormControl
            fullWidth
            variant={variant || 'outlined'}
            disabled={disabled}
            error={Boolean(error)}
          >
            <InputLabel
              ref={ref => {
                this.labelRef = ReactDOM.findDOMNode(ref)
              }}
              htmlFor={`formTextField${label}`}
              shrink
              style={
                variant === 'standard'
                  ? {}
                  : { transform: 'translate(44px, -6px) scale(0.75)' }
              }
            >
              {label}
            </InputLabel>
            {select ? (
              <Select
                value={value}
                onChange={handleValueChange}
                input={
                  <InputComponent
                    labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
                    id={`formTextField${label}`}
                    classes={
                      variant === 'standard'
                        ? {}
                        : {
                            notchedOutline: classes.notchedOutline,
                          }
                    }
                  />
                }
              >
                {selectTemplate
                  ? items.map(item => selectTemplate(item))
                  : items.map(item => (
                      <MenuItem
                        key={`formsFormValue${item.value}`}
                        value={item.value}
                      >
                        {item.label}
                      </MenuItem>
                    ))}
              </Select>
            ) : (
              <InputComponent
                id={`formTextField${label}`}
                labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
                value={value}
                onChange={handleValueChange}
                placeholder={placeholder}
                notched={variant !== 'standard'}
                classes={
                  variant === 'standard'
                    ? {}
                    : {
                        notchedOutline: classes.notchedOutline,
                      }
                }
                endAdornment={
                  color ? (
                    <ColorPicker
                      value={value}
                      handleFormValueChange={value =>
                        handleChange 
                          ? handleChange(property, value)
                          : onChange({ target: { value } })
                      }
                    />
                  ) : null
                }
                type={type}
              />
            )}
            <FormHelperText error={Boolean(error)}>{error || helperText}</FormHelperText>
          </FormControl>
        )
      }
    },
  ),
)
